import { formatCents, formatCompetence } from "../../utils/directorFormat";

const CashflowTable = ({
  months = [],
  selectedCompetence = null,
  onSelectCompetence,
}) => <div className="director-table-scroll">
  <table className="director-table" aria-label="Alternativa tabular do movimento financeiro">
    <thead>
      <tr>
        <th scope="col">Competência</th>
        <th scope="col">Entradas</th>
        <th scope="col">Saídas</th>
        <th scope="col">Fluxo líquido</th>
        <th scope="col">Fluxo líquido acumulado</th>
      </tr>
    </thead>
    <tbody>
      {months.map((month) => <tr
        className={selectedCompetence === month.competence ? "director-table__selected" : undefined}
        key={month.competence}
      >
        <th scope="row">
          {onSelectCompetence
            ? <button
                aria-current={selectedCompetence === month.competence ? "true" : undefined}
                className="director-table__competence"
                type="button"
                onClick={() => onSelectCompetence(month.competence)}
              >{formatCompetence(month.competence)}</button>
            : formatCompetence(month.competence)}
        </th>
        <td>{formatCents(month.inflow?.totalCents)}</td>
        <td>{formatCents(month.outflow?.totalCents)}</td>
        <td>{formatCents(month.netFlowCents)}</td>
        <td>{formatCents(month.accumulatedNetFlowCents)}</td>
      </tr>)}
    </tbody>
  </table>
</div>;

export default CashflowTable;
